import { createSelector } from 'reselect';
import { getProp } from '../../utilities';

const connectionsDomainSelector = state => state.connection;
const paramsDomainSelector = state => state.connectionParams;
const stepperDetailDomainSelector = state => state.stepper;

export const firstWayConnectionIdSelector = createSelector(
  stepperDetailDomainSelector,
  stepper => getProp(stepper, ['stepParams', 'firstWay', 'connectionId']),
);

export const secondWayConnectionIdSelector = createSelector(
  stepperDetailDomainSelector,
  stepper => getProp(stepper, ['stepParams', 'secondWay', 'connectionId']),
);

export const travelsSelector = createSelector(
  connectionsDomainSelector,
  paramsDomainSelector,
  stepperDetailDomainSelector,
  firstWayConnectionIdSelector,
  secondWayConnectionIdSelector,
  (connections, params, stepper, connectionId1, connectionId2) => {
    const type = getProp(params, ['ticketType']);
    const connection1 = getProp(connections, [
      'byId',
      connectionId1,
    ]);

    const rounds = getProp(connection1, ['sectors'], []).reduce(
      (prev, sector) => {
        return [
          ...prev,
          {
            roundId: sector.id_dps,
            from: sector.from_id_bus_stop,
            fromLabel: sector.from_bus_stop,
            to: sector.to_id_bus_stop,
            dateFrom: getProp(sector, ['time']),
            dateTo: getProp(sector, ['time_dest']),
            toLabel: sector.to_bus_stop,
            isSeating: sector.seating,
            buses: getProp(sector, ['busses'], []).reduce((p, buss) => {
              return [
                ...p,
                {
                  busId: buss.id_bus,
                  selectedSeats: getProp(
                    stepper,
                    ['stepParams', 'reservations', sector.id_dps, buss.id_bus],
                    [],
                  ),
                },
              ];
            }, []),
          },
        ];
      },
      [],
    );
    const ret = [];
    ret.push({
      rounds,
    });

    if (type === 'R') {
      const connection2 = getProp(connections, [
        'byId',
        connectionId2
      ]);
      const rounds = getProp(connection2, ['sectors'], []).reduce(
        (prev, sector) => {
          return [
            ...prev,
            {
              roundId: sector.id_dps,
              isSeating: sector.seating,
              from: sector.from_id_bus_stop,
              dateFrom: getProp(sector, ['time']),
              dateTo: getProp(sector, ['time_dest']),
              fromLabel: sector.from_bus_stop,
              to: sector.to_id_bus_stop,
              toLabel: sector.to_bus_stop,
              buses: getProp(sector, ['busses'], []).reduce((p, buss) => {
                return [
                  ...p,
                  {
                    busId: buss.id_bus,
                    selectedSeats: getProp(
                      stepper,
                      [
                        'stepParams',
                        'reservations',
                        sector.id_dps,
                        buss.id_bus,
                      ],
                      [],
                    ),
                  },
                ];
              }, []),
            },
          ];
        },
        [],
      );
      ret.push({
        rounds,
      });
    }
    return ret;
  },
);

export const isSeatingInWaysInSectorsSelector = createSelector(
  travelsSelector,
  substate => {
    let isSeating = false;
    substate.forEach(way => {
      way.rounds.forEach(sector => {
        if (sector.isSeating === true) {
          isSeating = true;
          return;
        }
      });
    });
    return isSeating;
  },
);

export const passengersNumber = createSelector(
  stepperDetailDomainSelector,
  substate => getProp(substate, ['stepParams', 'passengers'], []).length,
);



// WEBPACK FOOTER //
// ./src/containers/Reservation/selectors.js